import type { Control, FieldValues } from "react-hook-form";

import FormSection from "~/components/formElements/FormSection";
import Input from "~/components/formElements/Input";

type OrderTitleNumberFormSectionProps<T extends FieldValues> = {
	control: Control<T>;
	showOrderNumberInput?: boolean;
};

type FormDataType = {
	title: string;
	orderNumber: string | null;
};

const OrderTitleNumberFormSection = <T extends FormDataType>({
	control,
	showOrderNumberInput = true,
}: OrderTitleNumberFormSectionProps<T>) => {
	return (
		<FormSection title="Bestellung">
			<div className="grid grid-cols-6 gap-x-6 gap-y-2">
				<div className="col-span-6">
					<Input
						name="title"
						control={control}
						label="Bezeichung"
					/>
				</div>
				{showOrderNumberInput && <div className="col-span-6">
					<Input
						label="Bestellnummer"
						name="orderNumber"
						control={control}
					/>
				</div>}
			</div>
		</FormSection>
	);
};

export default OrderTitleNumberFormSection;
